/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
import React, {
  useState, Fragment, useEffect, useRef,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Select, Upload, Alert, notification,
} from 'antd';
import { H3_TITLE } from '@Apis/constants';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { InboxOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import Lottie from 'lottie-react';
import Shopify from '@Images/admin/integrations/shopify.png';
import Procuzy from '@Images/logo-without-tagline.png';
import Excel from '@Images/admin/integrations/excel.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import ForecastActions from '@Actions/application/forecastActions';
import { Column, Line } from '@ant-design/plots';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import forecastAnimation2 from '../../../media/lotties/forecast2.json';
import './style.scss';
import H3FormInput from '@Uilib/h3FormInput';
import ForecastResults from '@Components/Forecasting/ForecastForm/ForecastResults';
import ForecastAnalysis from '@Components/Forecasting/ForecastForm/ForecastAnalysis';
import PRZSelect from '../../Common/UI/PRZSelect';

const { Dragger } = Upload;

const { Option } = Select;
const waitMessages = [
  'validating the uploaded data',
  'removing outliers from the data',
  'finding out historical sales patterns',
];

/**
 *
 */
function ForecastForm({
  user, createForecast, createForecastLoading, getForecastById,
  selectedForecast, getForecastByIdLoading, getForecastByIdSuccess, match,
  startForecastLoading, startForecast, getForecastResults, getForecastResultsLoading,
}) {
  const [currentLoaderText, setCurrentLoaderText] = useState(0);
  const [currentStep, setCurrentStep] = useState(1);
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedDataSource, setSelectedDataSource] = useState('EXCEL');
  const [forecastName, setForecastName] = useState('');
  const [validationData, setValidationData] = useState('5');
  const [durationNumber, setDurationNumber] = useState('4');
  const [durationUnit, setDurationUnit] = useState('Weeks');
  const [target, setTarget] = useState('quantity');
  const [nullValues, setNullValues] = useState('remove');
  const [fileList, setFileList] = useState([]);

  const uploadProps = {
    name: 'file',
    multiple: false,
    accept: '.xlsx,.xls,.csv',
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    fileList,
    disabled: createForecastLoading,
  };
  const plugins = [
    {
      key: 'EXCEL',
      label: 'Excel/CSV',
      url: Excel,
      active: true,
    },
    {
      key: 'PROCUZY',
      label: 'Procuzy',
      url: Procuzy,
      active: false,
    },
    {
      key: 'SHOPIFY',
      label: 'Shopify',
      url: Shopify,
      active: false,
    },
  ];

  useEffect(() => {
    let textId = 0;
    const timeout = setInterval(() => {
      if (waitMessages[currentLoaderText + 1]) {
        textId += 1;
        setCurrentLoaderText(textId);
      } else {
        setCurrentLoaderText(0);
        textId = 0;
      }
    }, 5000);
    if (currentStep > 1) {
      clearInterval(timeout);
    }
    return () => {
      clearInterval(timeout);
    };
  }, [currentStep]);

  useEffect(() => {
    if (selectedForecast?.visualisation_data && selectedForecast?.status !== 'TRAINED') {
      setCurrentStep(2);
    }
    if (selectedForecast?.status === 'TRAINED') {
      setCurrentStep(3);
    }
  }, [selectedForecast]);

  useEffect(() => {
    if (!isUserReady) {
      setIsUserReady(true);
      if (match?.params?.forecastId) {
        setCurrentStep(2);
        getForecastById({
          forecast_id: match?.params?.forecastId,
        }, () => {

        });
      }
    }
  }, [isUserReady]);

  const onSubmit = () => {
    switch (currentStep) {
    case 1: {
      if (!fileList?.[0] || !forecastName) {
        notification.open({
          type: 'warning',
          message: 'Please provide input for all mandatory inputs',
          description: <Fragment>
            <ul>
              {!fileList?.[0] ? <li>Please upload a CSV data file</li> : ''}
              {!forecastName ? <li>Please enter a valid name for the forecast</li> : ''}
            </ul>
          </Fragment>,
          placement: 'top',
          duration: 4,
        });
      } else {
        createForecast({
          validationData,
          durationUnit,
          durationNumber,
          file: fileList[0],
          forecastName,
          tenantId: user?.tenant_info?.tenant_id,
          orgId: user?.tenant_info?.org_id,
          target,
          nullValues,
        }, (forecast) => {
          getForecastById({
            forecast_id: forecast?.forecast_id,
          });
        });
      }
      break;
    }
    case 2: {
      startForecast({
        forecast_id: selectedForecast?.forecast_id,
      }, () => {});
      break;
    }
    default: {
      break;
    }
    }
  };

  /**
   *
   */
  return (
    <Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{H3_TITLE}</title>
      </Helmet>
      {(createForecastLoading || getForecastByIdLoading || startForecastLoading || getForecastResultsLoading) && (
        <div className="forecast-form__loader">
          <div className="forecast-form__loader-icon">
            <Lottie
              animationData={forecastAnimation2}
              loop
            />
          </div>
          <H3Text
            text={`Please wait while we are ${waitMessages[currentStep] || 'finalising your data'}..`}
            className="forecast-form__loader-text"
          />
        </div>
      )}
      <div className="forecast-form">
        {selectedForecast?.status !== 'TRAINED' && !getForecastByIdLoading && (
          <div className="forecast-form__steps">
            <div className="forecast-step">
              <H3Text text="1" className={`forecast-step__count ${currentStep >= 1 ? 'forecast-step-selected' : ''} `} />
              <H3Text text="" className="forecast-step__count-line" />
            </div>
            <div className="forecast-step ">
              <H3Text text="2" className={`forecast-step__count ${currentStep >= 2 ? 'forecast-step-selected' : ''} `} />
              <H3Text text="" className="forecast-step__count-line" />
            </div>
            <div className="forecast-step">
              <H3Text text="3" className={`forecast-step__count ${currentStep >= 3 ? 'forecast-step-selected' : ''} `} />
            </div>
          </div>
        )}

        <div className="forecast-form__body" style={{ marginLeft: (!getForecastByIdLoading && selectedForecast?.status !== 'TRAINED') ? '70px' : '0px' }}>
          {(selectedForecast || match?.params?.forecastId) ? (
            <Fragment>
              {getForecastByIdLoading ? (
                <div className="forecast-result__loader">
                  <div className="loadingBlock" style={{ height: '40px', width: '70%' }} />
                  <div className="loadingBlock" style={{ height: '40px', width: '30%', marginTop: '5px' }} />
                  <div className="loadingBlock" style={{ height: '50px', width: '60%', marginTop: '30px' }} />
                  <div className="flex-display">
                    <div
                      className="loadingBlock"
                      style={{
                        height: '150px', width: '49%', marginTop: '20px', marginRight: '5px',
                      }}
                    />
                    <div className="loadingBlock" style={{ height: '150px', width: '49%', marginTop: '20px' }} />
                  </div>
                  <div className="flex-display">
                    <div
                      className="loadingBlock"
                      style={{
                        height: '150px', width: '49%', marginTop: '5px', marginRight: '5px',
                      }}
                    />
                    <div className="loadingBlock" style={{ height: '150px', width: '49%', marginTop: '5px' }} />
                  </div>
                </div>
              ) : (
                <Fragment>
                  {selectedForecast?.status === 'TRAINED' ? (
                    <ForecastResults />
                  )
                    : (
                      <ForecastAnalysis />
                    )}
                </Fragment>
              )}
            </Fragment>
          )
            : (
              <div className="forecast-form__wrapper">
                <div className="forecast-form__input-wrapper">
                  <label className="forecast-form__label">
                    Which data source do you want to use for your past sales data?
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                  <div className="forecast-form__plugins">
                    {
                          plugins?.map((item) => (
                            <div
                              key={item?.key}
                              className={`forecast-form__plugin 
                  ${selectedDataSource === item?.key ? 'forecast-form__plugin-selected' : ''} 
                  ${!item?.active ? 'forecast-form__plugin-disabled' : ''}`}
                              onClick={() => {
                                if (item?.active) {
                                  setSelectedDataSource(item?.key);
                                }
                              }}
                            >
                              <H3Image src={item?.url} className="forecast-form__plugin-image" />
                              {!item?.active && <H3Text text="coming soon" className="forecast-form__plugin-text" />}
                            </div>
                          ))
                    }
                  </div>
                </div>
                <div className="ant-row">
                  <div className="ant-col-md-12">
                    <div className="">
                      <H3FormInput
                        type="text"
                        placeholder="eg. Q2 Forecast Sep 21"
                        value={forecastName}
                        label="Please enter a name for your forecast"
                        onChange={(e) => setForecastName(e.target.value)}
                        maxlength={100}
                        containerClassName="forecast-form__input-wrapper"
                        labelClassName="forecast-form__label"
                        inputClassName="forecast-form__input"
                        required
                      />
                    </div>
                  </div>
                  <div className="ant-col-md-12">
                    <div className="forecast-form__input-wrapper">
                      <label className="forecast-form__label">
                        What percentage of data do you want use for validation?
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                      <PRZSelect
                        value={validationData}
                        onChange={(val) => setValidationData(val)}
                        showSearch={false}
                      >
                        <Option value="5">5%</Option>
                        <Option value="10">10%</Option>
                        <Option value="15">15%</Option>
                        <Option value="20">20%</Option>
                      </PRZSelect>
                    </div>
                  </div>
                  <div className="ant-col-md-24">
                    <div className="forecast-form__input-wrapper">
                      <label className="forecast-form__label">
                        Please select the duration for the forecast
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                      <div className="forecast-form__duration">
                        <PRZSelect
                          value={durationNumber}
                          onChange={(val) => setDurationNumber(val)}
                          showSearch={false}
                        >
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12].map((item) => (<Option value={item} key={item}>{item}</Option>))}
                        </PRZSelect>
                        <PRZSelect
                          value={durationUnit}
                          onChange={(val) => setDurationUnit(val)}
                          showSearch={false}
                        >
                          {['Weeks', 'Months'].map((item) => (<Option value={item} key={item}>{item}</Option>))}
                        </PRZSelect>
                      </div>
                    </div>
                  </div>
                  <div className="ant-col-md-12">
                    <div className="forecast-form__input-wrapper" style={{ width: 'calc(100% - 2px)' }}>
                      <label className="forecast-form__label">
                        Do you want forecast stock levels or sales?
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                      <PRZSelect
                        value={target}
                        onChange={(val) => setTarget(val)}
                        showSearch={false}
                      >
                        <Option value="quantity">Stock Levels</Option>
                        <Option value="sales">Sales</Option>
                      </PRZSelect>
                    </div>
                  </div>
                  <div className="ant-col-md-12">
                    <div className="forecast-form__input-wrapper">
                      <label className="forecast-form__label">
                        What should we do with the empty values on your data?
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                      <PRZSelect
                        value={nullValues}
                        onChange={(val) => setNullValues(val)}
                        showSearch={false}
                      >
                        <Option value="remove">Discard Empty Values</Option>
                        <Option value="fill">Consider as 0</Option>
                      </PRZSelect>
                    </div>
                  </div>
                  <div className="ant-col-md-24">
                    <div className="forecast-form__input-wrapper">
                      <label className="forecast-form__label">
                        Please upload this historical sales data in a CSV format
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                      <Dragger {...uploadProps}>
                        <p className="ant-upload-drag-icon">
                          <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                        <p className="ant-upload-hint">
                          Please upload sales data in Procuzy's data template only
                        </p>
                      </Dragger>
                      <Alert
                        showIcon
                        message={(
                          <div>
                            <a>Click here</a>
                            {' '}
                            to download the data template
                          </div>
                        )}
                        type="warning"
                        style={{ borderRadius: '4px' }}
                      />
                    </div>
                  </div>
                  <div className="ant-col-md-8">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="Begin Data Processing"
                      onClick={() => onSubmit()}
                      isLoading={createForecastLoading}
                      disabled={createForecastLoading}
                      style={{
                        width: '180px',
                        borderRadius: '5px',
                        padding: '10px 0px',
                        marginLeft: '0',
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
        </div>

      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, ForecastReducers,
}) => ({
  user: UserReducers.user,
  createForecastLoading: ForecastReducers.createForecastLoading,
  getForecastByIdLoading: ForecastReducers.getForecastByIdLoading,
  selectedForecast: ForecastReducers.selectedForecast,
  startForecastLoading: ForecastReducers.startForecastLoading,
  getForecastResultsLoading: ForecastReducers.getForecastResultsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createForecast: (formData, callback) => dispatch(ForecastActions.createForecast(formData, callback)),
  startForecast: (payload, callback) => dispatch(ForecastActions.startForecast(payload, callback)),
  getForecastResults: (payload, callback) => dispatch(ForecastActions.getForecastResults(payload, callback)),
  getForecastById: (payload, callback) => dispatch(ForecastActions.getForecastById(payload, callback)),
  getForecastByIdSuccess: (selectedForecast) => dispatch(ForecastActions.getForecastByIdSuccess(selectedForecast)),
});

ForecastForm.propTypes = {
  user: PropTypes.any,
  createForecast: PropTypes.func,
  createForecastLoading: PropTypes.bool,
  getForecastById: PropTypes.func,
  getForecastByIdLoading: PropTypes.bool,
  startForecastLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ForecastForm));
